import { render, staticRenderFns } from "./ProgramPrice.vue?vue&type=template&id=68f6cb26&"
import script from "./ProgramPrice.vue?vue&type=script&lang=js&"
export * from "./ProgramPrice.vue?vue&type=script&lang=js&"
import style0 from "./ProgramPrice.vue?vue&type=style&index=0&id=68f6cb26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports